<template>
    <div fluid fill-height >
      <v-expand-x-transition>
        <landing-toolbar />
      </v-expand-x-transition>
      <v-container style="min-width:95% !important;overflow: hidden;">
        <ModelsLiquidation />
      </v-container>
    </div>
</template>
  
  <script>

  import LandingToolbar from '../../components/LandingToolbar/LandingToolbar.vue'
  import ModelsLiquidation from '../../components/Definiciones/ModelosDeLiquidacion/Main.vue'
  export default {
    components: { ModelsLiquidation, LandingToolbar },
  };
  </script>


  
  